__turbopack_context__.v({
  "articlePage": "ArticlePageTemplate-module__Qoqngq__articlePage",
  "aside": "ArticlePageTemplate-module__Qoqngq__aside" + " " + "cds-grid__sidebar",
  "grid": "ArticlePageTemplate-module__Qoqngq__grid" + " " + "cds-grid__row",
  "main": "ArticlePageTemplate-module__Qoqngq__main" + " " + "cds-grid__main",
  "related": "ArticlePageTemplate-module__Qoqngq__related",
});
